<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div data-slot="field-content" :class="cn('flex min-w-0 flex-1 flex-col gap-1', props.class)">
    <slot />
  </div>
</template>
